import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DealerLayout from '../layouts/dealer';
import CoELayout from '../layouts/CoE';
import SalesUserLayout from '../layouts/jjsales';
import DashboardParamLayout from '../layouts/dashboardparamlayout';
import HelpAndCommunicationLayout from '../layouts/helpandcommunicationlayout'
import AdminLayout from '../layouts/adminlayout'
import NetRetailLayout from '../layouts/netRetail/NetRetailLayout'
import SupervisorLayout from '../layouts/supervisor/supervisorLayout';
import NSMLayout from '../layouts/NSM/NSMLayout';
import BSLayout from '../layouts/branchsecretorylayout/branchsecretorylayout';
import BranchSecretaryLayout from '../layouts/branchsecretary/BranchSecretaryLayout';
import AllPagesLayout from '../layouts/allpages/AllPagesLayout';
import COEAdminLayout from '../layouts/COEAdmin/COEAdminLayout';
import ReportUserLayout from '../layouts/reportuser/ReportUserLayout';
import DashboardAndReportUserLayout from '../layouts/dashboardandreportuser/DashboardAndReportUserLayout';
import MasterUserLayout from '../layouts/masteruser/MasterUserLayout';
import MasterViewerLayout from '../layouts/masterviewer/MasterViewerLayout';
//
import {
    Page404,
    CommingSoonPage,
    MainLogin,
    StepOne,
    StepThree,
    DataUploadApprovePage,
    DataMappingPage,
    DataMappingProductPage,
    DataMappingAccountPage,
    DataMappingSurgeonPage,
    EnableReuploadPage,
    Mapping,
    DealerDataMappingPage,
    DataMappingFormPage,
    Masters,
    DealerViewData,
    UploadStepOne,
    UploadStepThree,
    NonEligibleRecordPage,
    MasterList,
    ManualDataPage,
    ManualDataCreate,
    ViewInvoiceForm,
    CloseMonth,
    OnlineEntryPage2,
    OnlineEntryPage4,
    OnlineEntryPage3,
    OnlineEntryPage5,
    MyRequestPage,
    DealerRequestPage,
    DealerAccountRequestPage,
    DealerSuregonRequestPage,
    CalenderPage,
    DashboardPage,
    UnmappedDataEntries,
    RaiseTicketPage,
    DataUploadPage,
    UserMasterList,
    UserData,
    DistributorConfigurationPage,
    ClosureMonthPage,
    AllProductsPage,
    AllCustomersPage,
    DashboardParametersPage,
    DataUploadPageV1,
    DataUploadV1StepOne,
    DataUploadV1StepTwo,
    EntLogin,
    CutOffDatePage,
    NotificationPage,
    TransactionReportPage,
    ReportPage,
    DealerListPage,
    SalesDashboardPage,
    SNSUploadPage,
    SNSUploadStep1,
    SNSUploadStep2,
    JJConnectLink,
    TransactionReport, DealerPriceReport, DealerReport, DumpReportPage, DumpReport, SalesReport, SalesReportPage, TerritoryDumpReport, TerritoryDumpReportPage,
    SNSViewDataPage,
    Errorpage,
    DataMappingImportStep1,
    DataMappingImportStep2,
    DataMappingImportStep3,
    DataMappingDownloadStep2,
    ReprocessZylemDataPage,
    DealerPurchaseReportPage,
    DealerPurchaseReport,
    ActivityLogPage,
    ActivityLog,
    InventoryReport,
    InventoryReportPage,
    CoeDataUploadPage,
    CoeDataUploadStepOne,
    CoeDataUploadStepTwo,
    CoeDataUpload, DealerDataStatusReportPage, DealerDataStatusReport, DealerReportedSNSDataPage, DealerReportedSNSDataReport
    , HelpAndDocuments, HelpAndCommunicationViewPage, HelpTopics, SubCategory, AddEditSubCategory,
    AddEditHelpTopics, AdminMasters, HelpCommonPage, HelpCommunicationSearchPage, DSRPDCPRIDumpPage, SupervisorMaster, SupervisorDataUploadStepOne, SupervisorDataUploadStepTwo, DSRPDCPRIDumpStep1, DSRPDCPRIDumpStep2, RequestorPage, AnalyticsPage, BSReportPage, HistoryPage, SettingsPage, MainRequestPage, GeneralStepTwo,
    SetManagementCommonPage, ApproveStatusPage, GeneralStepThree, GeneralPreviewPage, BSDashboardPage, NSMDashoardPage, NSMRequestPage, BSRequestorPage, BSRequestorNewSetPage,
    DealerSNSReportPage,
    DealerSNSReport,
    ReadOnlyMaster,
    ReadOnlyMasterList,
    GrossSalesReportPage,
    GrossSalesReport,
    StandardPriceReportPage,
    StandardPriceReport,
    ModuleRoleAccessListPage, ModuleRoleAccessList,
    GrossSaleDetailedReportExport,
    InventoryPage,
    YTDDumpReport,
    YTDDumpReportPage,
    GrossSalePage,
    DataPage,
    EntGateLogin,
    PowerBIDashboardPage,
    Logout,
    FranchiseWiseCutOffPage
} from './elements';
import SetDealerLayout from '../layouts/setDealer';
import MainDealerPage from '../pages/SetMgt/Dealer/maindealerpage';
import AcknowledgementPage from '../pages/SetMgt/Dealer/acknowledgementpage';

// ----------------------------------------------------------------------------------------------

export default function Router() {
    return useRoutes([
        {
            path: '/',
            children: [
                { element: <Navigate to='entgatelogin' replace />, index: true },
                {
                    path: 'login',
                    element: (
                        <GuestGuard>
                            <MainLogin />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'entgatelogin',
                    element: (
                        <GuestGuard>
                            <EntGateLogin />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'logout',
                    element: (
                        <GuestGuard>
                            <Logout />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'help',
                    element: (
                        <GuestGuard>
                            <HelpCommonPage />
                        </GuestGuard>
                    ),
                }, {
                    path: 'grosstonet',
                    element: (
                        <GuestGuard>
                            <HelpCommonPage />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'setmanagement',
                    element: (
                        <GuestGuard>
                            <SetManagementCommonPage />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'entlogin',
                    element: (
                        <GuestGuard>
                            < EntLogin />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'commingsoonpage',
                    element: (
                        <GuestGuard>
                            <CommingSoonPage />
                        </GuestGuard>
                    ),
                },
                {
                    path: 'error/errorpage',
                    element: (
                        <GuestGuard>
                            <Errorpage />
                        </GuestGuard>
                    ),
                },

            ],
        },
        {
            path: '/dealer',
            element: (
                <GuestGuard>
                    <DealerLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/dealer/powerbidashboard' replace />, index: true },
                { path: 'dashboard', element: <DashboardPage /> },
                //    { path: 'dashboard/dashboardparameter', element: <DashboardParametersPage /> },
                { path: 'dashboard/allproducts', element: <AllProductsPage /> },
                { path: 'dashboard/allcustomers', element: <AllCustomersPage /> },

                { path: ':uploadName/mapping', element: <Mapping /> },
                { path: ':uploadName/viewdata', element: <DealerViewData /> },
                { path: ':uploadName', element: <DataUploadPageV1 /> },

                { path: ":uploadName/dealeruploadstepone", element: <UploadStepOne /> },
                { path: ":uploadName/datauploadv1stepone", element: <DataUploadV1StepOne /> },
                { path: ":uploadName/datauploadv1steptwo", element: <DataUploadV1StepTwo /> },
                { path: ":uploadName/dealeruploadstepthree", element: <UploadStepThree /> },
                { path: ":uploadName/unmappeddataentries", element: <UnmappedDataEntries /> },

                { path: "snsupload", element: <SNSUploadPage /> },
                { path: "snsupload/snsuploadstep1", element: <SNSUploadStep1 /> },
                { path: "snsupload/snsuploadstep2", element: <SNSUploadStep2 /> },
                { path: "snsupload/snsviewdata", element: <SNSViewDataPage /> },

                { path: 'dealerdatamapping', element: <DealerDataMappingPage /> },
                { path: 'datamappingform', element: <DataMappingFormPage /> },

                { path: 'myrequest', element: <MyRequestPage /> },

                { path: 'closuremonth', element: <ClosureMonthPage /> },

                { path: 'manualdata', element: <ManualDataPage /> },
                { path: 'manualdata/manualdatacreate', element: <ManualDataCreate /> },
                { path: 'closuremonth/closemonth', element: <CloseMonth /> },
                { path: 'manualdata/viewinvoiceform', element: <ViewInvoiceForm /> },
                { path: 'calender', element: <CalenderPage /> },

                { path: 'manualdata/onlineentrypage2', element: <OnlineEntryPage2 /> },
                { path: 'manualdata/onlineentrypage4', element: <OnlineEntryPage4 /> },
                { path: 'manualdata/onlineentry3', element: <OnlineEntryPage3 /> },
                { path: 'manualdata/onlineentry5', element: <OnlineEntryPage5 /> },
                { path: 'notificationpage', element: <NotificationPage /> },
                { path: 'jjconnectlink', element: <JJConnectLink /> },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to="datapage" replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'dealersnsreportpage', element: <DealerSNSReportPage /> },
                        { path: 'grosssalesreportpage', element: <GrossSalesReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'territorydumpreportpage', element: <TerritoryDumpReportPage /> },
                    ],
                },
                // { path: 'helpandcommunication', element: <HelpAndDocuments /> },

                { path: 'powerbidashboard', element: <PowerBIDashboardPage /> },  // Power BI dashboard : 23-Jun-2025 Added by Karishma
            ],
        },
        {
            path: '/coe',
            element: (
                <GuestGuard>
                    <CoELayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/coe/datauploadapprove' replace />, index: true },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'reloadzylemdata', element: <ReprocessZylemDataPage /> },
                { path: 'coedataupload', element: <CoeDataUploadPage /> },
                { path: 'coedataupload/coedatauploadmain', element: <CoeDataUpload /> },
                { path: 'coedataupload/coedatauploadstepone', element: <CoeDataUploadStepOne /> },
                { path: 'coedataupload/coedatauploadsteptwo', element: <CoeDataUploadStepTwo /> },
                { path: 'dataupload', element: <DataUploadPage /> },
                { path: 'datamapping', element: <DataMappingPage /> },
                { path: 'datamapping/datamappingproductpage', element: <DataMappingProductPage /> },
                { path: 'datamapping/datamappingaccountpage', element: <DataMappingAccountPage /> },
                { path: 'datamapping/datamappingsurgeonpage', element: <DataMappingSurgeonPage /> },
                { path: "datamapping/datamappingimportstep1", element: <DataMappingImportStep1 /> },
                { path: "datamapping/:importName/datamappingimportstep2", element: <DataMappingImportStep2 /> },
                { path: "datamapping/:importName/datamappingimportstep3", element: <DataMappingImportStep3 /> },
                { path: "datamapping/:importName/datamappingdownloadstep2", element: <DataMappingDownloadStep2 /> },
                { path: 'dealerrequest', element: <DealerRequestPage /> },
                { path: 'dealerrequest/dealeraccountrequest', element: <DealerAccountRequestPage /> },
                { path: 'dealerrequest/dealersugeonrequest', element: <DealerSuregonRequestPage /> },
                { path: 'enablereupload', element: <EnableReuploadPage /> },
                { path: 'noneligiblerecordsapprove', element: <NonEligibleRecordPage /> },
                { path: 'raiseticketrequest/raiseticketpage', element: <RaiseTicketPage /> },
                /*  { path: 'datamapping', element: <DataMappingPage /> },    */
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/coe/master/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='masterlist' /> },
                        { path: ":masterName", element: <Masters importkey='master' /> },
                        { path: "usermasterlist", element: <UserMasterList name='coeusermasterlist' /> },
                        { path: "userdata", element: <UserData /> },

                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'alliedmaster',
                    children: [
                        { element: <Navigate to="/coe/alliedmaster/alliedmasterlist" replace />, index: true },
                        { path: "alliedmasterlist", element: <MasterList name='alliedmasterlist' /> },
                        { path: ":masterName", element: <Masters importkey="alliedmaster" /> },
                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to="datapage" replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                { path: 'configuration', element: <DistributorConfigurationPage /> },
                { path: "cutoffdatepage", element: <CutOffDatePage /> },
                { path: "franchisewisecutoff", element: <FranchiseWiseCutOffPage /> },
                {
                    path: 'myreport',
                    children: [
                        { element: <Navigate to="myreportpage" replace />, index: true },
                        { path: 'myreportpage', element: <ReportPage /> },
                        { path: 'territorydumpreportpage', element: <TerritoryDumpReportPage /> },
                        { path: 'dealerpurchasereportpage', element: <DealerPurchaseReportPage /> },
                        { path: 'inventoryreportpage', element: <InventoryReportPage /> },
                    ],
                },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dumpreportpage', element: <DumpReportPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'territorydumpreportpage', element: <TerritoryDumpReportPage /> },
                        { path: 'dealerpurchasereportpage', element: <DealerPurchaseReportPage /> },
                        { path: 'activitylogpage', element: <ActivityLogPage /> },
                        { path: 'inventoryreportpage', element: <InventoryReportPage /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'dealersnsreportpage', element: <DealerSNSReportPage /> },
                        { path: 'grosssalesreportpage', element: <GrossSalesReportPage /> },
                        { path: 'standardpricereportpage', element: <StandardPriceReportPage /> },
                        { path: 'moduleroleaccesslistpage', element: <ModuleRoleAccessListPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },
        {
            path: '/salesuser',
            element: (
                <GuestGuard>
                    <SalesUserLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/salesuser/datauploadapprove' replace />, index: true },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'dealerlistpage', element: <DealerListPage /> },
                { path: 'salesdashboard', element: <SalesDashboardPage /> },
                { path: 'powerbidashboard', element: <PowerBIDashboardPage /> },
                //    { path: 'dashboard/dashboardparameter', element: <DashboardParametersPage /> },
                { path: 'dashboard/allproducts', element: <AllProductsPage /> },
                { path: 'dashboard/allcustomers', element: <AllCustomersPage /> },
                { path: 'dashboard/allcustomers', element: <AllCustomersPage /> },
                {
                    path: 'readonlymaster',
                    children: [
                        { element: <Navigate to="/salesuser/readonlymaster/readonlymasterlist" replace />, index: true },
                        { path: "readonlymasterlist", element: <ReadOnlyMasterList name='masterlist' /> },
                        { path: ":masterName", element: <ReadOnlyMaster importkey='master' /> },
                    ],
                },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to="datapage" replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                { element: <Navigate to='/salesuser/myreport/reportpage' replace />, index: true },
                {
                    path: 'myreport',
                    children: [
                        { element: <Navigate to="myreportpage" replace />, index: true },
                        { path: 'myreportpage', element: <ReportPage /> },
                        { path: 'salesreportpage', element: <SalesReportPage /> },
                        //  { path: 'dumpreportpage', element: <DumpReportPage /> },
                        // { path: 'dealerreportpage', element: <DealerPriceReport /> },
                    ],
                },
                { element: <Navigate to='/salesuser/report/reportpage' replace />, index: true },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dumpreportpage', element: <DumpReportPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'salesreportpage', element: <SalesReportPage /> },
                        { path: 'dealersnsreportpage', element: <DealerSNSReportPage /> },
                        { path: 'grosssalesreportpage', element: <GrossSalesReportPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },
        {
            path: '/dashboardparam',
            element: (
                <GuestGuard>
                    <DashboardParamLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/dashboardparam/dashboardparameter' replace />, index: true },
                { path: 'dashboardparameter', element: <DashboardParametersPage /> },
                { path: 'transactionreport', element: <TransactionReport /> },
                { path: 'dumpreport', element: <DumpReport /> },
                { path: 'salesreport', element: <SalesReport /> },
                { path: 'territoryreport', element: <TerritoryDumpReport /> },
                { path: 'dealerreport', element: <DealerReport /> },
                { path: 'dealerpurchasereport', element: <DealerPurchaseReport /> },
                { path: 'dealerdatastatusreport', element: <DealerDataStatusReport /> },
                { path: 'dealerreportedsnsdatareport', element: <DealerReportedSNSDataReport /> },
                { path: 'inventoryreport', element: <InventoryReport /> },
                { path: 'salesreport', element: <SalesReport /> },
                { path: 'territoryreport', element: <TerritoryDumpReport /> },
                { path: 'activitylog', element: <ActivityLog /> },
                { path: 'allproducts', element: <AllProductsPage /> },
                { path: 'allcustomers', element: <AllCustomersPage /> },
                { path: 'helpandcommunication', element: <HelpAndDocuments /> },
                { path: 'dealersnsreport', element: <DealerSNSReport /> },
                { path: 'grosssalesreport', element: <GrossSalesReport /> },
                { path: 'standardpricereport', element: <StandardPriceReport /> },
                { path: 'moduleroleaccesslist', element: <ModuleRoleAccessList /> },
                { path: 'grosssaledetailedreportexport', element: <GrossSaleDetailedReportExport /> },
                { path: 'ytddumpreport', element: <YTDDumpReport /> },
            ],
        },
        {
            path: '/helpandcommunication',
            element: (
                <GuestGuard>
                    <HelpAndCommunicationLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='home/:title' replace target="_blank" />, index: true },
                { path: 'home', element: <HelpAndDocuments target="_blank" /> },
                { path: 'home/:title', element: <HelpAndDocuments target="_blank" /> },
                { path: 'home/', element: <HelpAndDocuments target="_blank" /> },
                { path: 'home/:title/:subcategoryname', element: <HelpAndDocuments target="_blank" /> },
                { path: 'details/:title/qmenu/:menuname', element: <HelpAndCommunicationViewPage /> },
                { path: 'details/:title', element: <HelpAndCommunicationViewPage /> },
                { path: 'searchedresults', element: <HelpCommunicationSearchPage /> },
                { path: 'searchedresults/:subcategoryname', element: <HelpCommunicationSearchPage target="_blank" /> },
            ],
        },
        {
            path: '/helpadmin',
            element: (
                <GuestGuard>
                    <AdminLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/helpadmin/helptopics' replace />, index: true },

                //  { path: 'helpcategory', element: <HelpCategoryPage /> },
                { path: ":masterName", element: <AdminMasters importkey='master' /> },
                { path: "helptopics", element: <HelpTopics /> },
                { path: "subcategory", element: <SubCategory /> },
                { path: ':masterName/stepone', element: <StepOne /> },
                { path: ':masterName/stepthree', element: <StepThree /> },
                { path: 'helptopics/addedithelptopics', element: <AddEditHelpTopics /> },
                { path: 'subcategory/addeditsubcategory', element: <AddEditSubCategory /> },
            ],
        },
        {
            path: '/supervisor',
            element: (
                <GuestGuard>
                    <SupervisorLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/supervisor/masterlist' replace />, index: true },
                { path: "/supervisor/masterlist", element: <MasterList name='supervisorlist' /> },
                {
                    path: 'netretailing',
                    children: [
                        { element: <Navigate to="/supervisor/netretailing/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='supervisorlist' /> },
                        { path: ":masterName", element: <SupervisorMaster importkey='netretailing' /> },


                        { path: ':masterName/stepone', element: <SupervisorDataUploadStepOne /> },
                        { path: ':masterName/steptwo', element: <SupervisorDataUploadStepTwo /> },
                    ],
                },

            ],
        },
        {
            path: '/setmanagementb',
            element: (
                <GuestGuard>
                    <BSLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/setmanagementb/bs/bsrequestor' replace />, index: true },
                {
                    path: 'bs',
                    children: [
                        { path: "/setmanagementb/bs/home", element: <BSDashboardPage /> },
                        { path: "/setmanagementb/bs/setrequests", element: <MainRequestPage /> },
                        { path: "/setmanagementb/bs/setrequests/stepone", element: <RequestorPage /> },
                        { path: "/setmanagementb/bs/setrequests/steptwo", element: <GeneralStepTwo /> },
                        { path: "/setmanagementb/bs/setrequests/stepthree", element: <GeneralStepThree /> },
                        { path: "/setmanagementb/bs/setrequests/preview", element: <GeneralPreviewPage /> },
                        { path: "/setmanagementb/bs/settings", element: <SettingsPage /> },
                        { path: "/setmanagementb/bs/analytics", element: <AnalyticsPage /> },
                        { path: "/setmanagementb/bs/reports", element: <BSReportPage /> },
                        { path: "/setmanagementb/bs/history", element: <HistoryPage /> },
                        { path: "/setmanagementb/bs/bsrequestor", element: <BSRequestorPage /> },
                        { path: "/setmanagementb/bs/bsrequestor/bsrequestornesetpage", element: <BSRequestorNewSetPage /> },

                    ]
                },
                {
                    path: 'reports',
                    children: [
                        { path: "/setmanagementb/reports/home", element: <BSRequestorPage /> },
                    ]
                }
            ],
        },
        {
            element: <CompactLayout />,
            children: [{ path: '404', element: <Page404 /> }],
        },
        { path: '*', element: <Navigate to="/404" replace /> },
        {
            path: '/netretaillayout',
            element: (
                <GuestGuard>
                    <NetRetailLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'netretail',
                    children: [
                        { element: <Navigate to="/netretaillayout/netRetail/dsr_pdc_priDump" replace />, index: true },
                        { path: "dsr_pdc_priDump", element: <DSRPDCPRIDumpPage /> },
                        { path: "dsr_pdc_priDumpStep1", element: <DSRPDCPRIDumpStep1 /> },
                        { path: "dsr_pdc_priDumpStep2", element: <DSRPDCPRIDumpStep2 /> },
                    ],
                }
            ],
        },
        {
            path: '/nsm',
            element: (
                <GuestGuard>
                    <NSMLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'nsm',
                    children: [
                        { element: <Navigate to="/nsm/nsm/home" replace />, index: true },
                        { path: "setrequests/approvestatuspage", element: <ApproveStatusPage /> },
                        { path: "home", element: <NSMDashoardPage /> },
                        { path: "setrequests", element: <NSMRequestPage /> }
                    ],
                }
            ],
        },

        {
            path: '/setdealer',
            element: (
                <GuestGuard>
                    <SetDealerLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'setdealer',
                    children: [
                        { element: <Navigate to="/setdealer/setdealer/maindealerpage" replace />, index: true },
                        { path: "maindealerpage", element: <MainDealerPage /> },
                        { path: "maindealerpage/detailsandacknowledgement", element: <AcknowledgementPage /> }
                    ],
                }
            ],
        },
        {
            path: '/branchsecretary',
            element: (
                <GuestGuard>
                    <BranchSecretaryLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/branchsecretary/datauploadapprove' replace />, index: true },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'dealerlistpage', element: <DealerListPage /> },
                { path: 'salesdashboard', element: <SalesDashboardPage /> },
                //    { path: 'dashboard/dashboardparameter', element: <DashboardParametersPage /> },
                { path: 'dashboard/allproducts', element: <AllProductsPage /> },
                { path: 'dashboard/allcustomers', element: <AllCustomersPage /> },
                {
                    path: 'readonlymaster',
                    children: [
                        { element: <Navigate to="/branchsecretary/readonlymaster/readonlymasterlist" replace />, index: true },
                        { path: "readonlymasterlist", element: <ReadOnlyMasterList name='masterlist' /> },
                        { path: ":masterName", element: <ReadOnlyMaster importkey='master' /> },
                    ],
                },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="/branchsecretary/report/reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'salesreportpage', element: <SalesReportPage /> },
                        { path: 'dumpreportpage', element: <DumpReportPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },

        /*
         CODE       DATE            CHANGED BY          DESCRIPTION
         CD002      05-JUN-2025     Karishma Mithari    Changes to add new layout for all pages
        */

        // Started CD002
        {
            path: '/allpages',
            element: (
                <GuestGuard>
                    <AllPagesLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/allpages/datauploadapprove' replace />, index: true },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'reloadzylemdata', element: <ReprocessZylemDataPage /> },
                { path: 'datamapping', element: <DataMappingPage /> },
                { path: 'datamapping/datamappingproductpage', element: <DataMappingProductPage /> },
                { path: 'datamapping/datamappingaccountpage', element: <DataMappingAccountPage /> },
                { path: 'datamapping/datamappingsurgeonpage', element: <DataMappingSurgeonPage /> },
                { path: "datamapping/datamappingimportstep1", element: <DataMappingImportStep1 /> },
                { path: "datamapping/:importName/datamappingimportstep2", element: <DataMappingImportStep2 /> },
                { path: "datamapping/:importName/datamappingimportstep3", element: <DataMappingImportStep3 /> },
                { path: "datamapping/:importName/datamappingdownloadstep2", element: <DataMappingDownloadStep2 /> },
                { path: 'enablereupload', element: <EnableReuploadPage /> },
                { path: 'configuration', element: <DistributorConfigurationPage /> },
                { path: "cutoffdatepage", element: <CutOffDatePage /> },
                { path: "franchisewisecutoff", element: <FranchiseWiseCutOffPage /> },
                { path: 'dealerlistpage', element: <DealerListPage /> },
                { path: 'salesdashboard', element: <SalesDashboardPage /> },
                { path: 'dashboard/allproducts', element: <AllProductsPage /> },
                { path: 'dashboard/allcustomers', element: <AllCustomersPage /> },
                { path: 'dashboard/allcustomers', element: <AllCustomersPage /> },
                { path: "helptopics", element: <HelpTopics /> },
                { path: "subcategory", element: <SubCategory /> },
                { path: 'helptopics/addedithelptopics', element: <AddEditHelpTopics /> },
                { path: 'subcategory/addeditsubcategory', element: <AddEditSubCategory /> },
                { path: ":masterName", element: <AdminMasters importkey='master' /> },
                { path: ':masterName/stepone', element: <StepOne /> },
                { path: ':masterName/stepthree', element: <StepThree /> },
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/allpages/master/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='masterlist' /> },
                        { path: ":masterName", element: <Masters importkey='master' /> },

                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'alliedmaster',
                    children: [
                        { element: <Navigate to="/allpages/alliedmaster/alliedmasterlist" replace />, index: true },
                        { path: "alliedmasterlist", element: <MasterList name='alliedmasterlist' /> },
                        { path: ":masterName", element: <Masters importkey="alliedmaster" /> },
                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to="datapage" replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dumpreportpage', element: <DumpReportPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'territorydumpreportpage', element: <TerritoryDumpReportPage /> },
                        { path: 'dealerpurchasereportpage', element: <DealerPurchaseReportPage /> },
                        { path: 'activitylogpage', element: <ActivityLogPage /> },
                        { path: 'inventoryreportpage', element: <InventoryReportPage /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'dealersnsreportpage', element: <DealerSNSReportPage /> },
                        { path: 'grosssalesreportpage', element: <GrossSalesReportPage /> },
                        { path: 'standardpricereportpage', element: <StandardPriceReportPage /> },
                        { path: 'moduleroleaccesslistpage', element: <ModuleRoleAccessListPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },
        {
            path: '/coe',
            element: (
                <GuestGuard>
                    <COEAdminLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/coe/datauploadapprove' replace />, index: true },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'reloadzylemdata', element: <ReprocessZylemDataPage /> },
                { path: 'coedataupload', element: <CoeDataUploadPage /> },
                { path: 'coedataupload/coedatauploadmain', element: <CoeDataUpload /> },
                { path: 'coedataupload/coedatauploadstepone', element: <CoeDataUploadStepOne /> },
                { path: 'coedataupload/coedatauploadsteptwo', element: <CoeDataUploadStepTwo /> },
                { path: 'dataupload', element: <DataUploadPage /> },
                { path: 'datamapping', element: <DataMappingPage /> },
                { path: 'datamapping/datamappingproductpage', element: <DataMappingProductPage /> },
                { path: 'datamapping/datamappingaccountpage', element: <DataMappingAccountPage /> },
                { path: 'datamapping/datamappingsurgeonpage', element: <DataMappingSurgeonPage /> },
                { path: "datamapping/datamappingimportstep1", element: <DataMappingImportStep1 /> },
                { path: "datamapping/:importName/datamappingimportstep2", element: <DataMappingImportStep2 /> },
                { path: "datamapping/:importName/datamappingimportstep3", element: <DataMappingImportStep3 /> },
                { path: "datamapping/:importName/datamappingdownloadstep2", element: <DataMappingDownloadStep2 /> },
                { path: 'dealerrequest', element: <DealerRequestPage /> },
                { path: 'dealerrequest/dealeraccountrequest', element: <DealerAccountRequestPage /> },
                { path: 'dealerrequest/dealersugeonrequest', element: <DealerSuregonRequestPage /> },
                { path: 'enablereupload', element: <EnableReuploadPage /> },
                { path: 'noneligiblerecordsapprove', element: <NonEligibleRecordPage /> },
                { path: 'raiseticketrequest/raiseticketpage', element: <RaiseTicketPage /> },
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/coe/master/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='masterlist' /> },
                        { path: ":masterName", element: <Masters importkey='master' /> },
                        { path: "usermasterlist", element: <UserMasterList name='coeusermasterlist' /> },
                        { path: "userdata", element: <UserData /> },
                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'alliedmaster',
                    children: [
                        { element: <Navigate to="/coe/alliedmaster/alliedmasterlist" replace />, index: true },
                        { path: "alliedmasterlist", element: <MasterList name='alliedmasterlist' /> },
                        { path: ":masterName", element: <Masters importkey="alliedmaster" /> },
                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to="datapage" replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                { path: 'configuration', element: <DistributorConfigurationPage /> },
                { path: "cutoffdatepage", element: <CutOffDatePage /> },
                { path: "franchisewisecutoff", element: <FranchiseWiseCutOffPage /> },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dumpreportpage', element: <DumpReportPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'territorydumpreportpage', element: <TerritoryDumpReportPage /> },
                        { path: 'dealerpurchasereportpage', element: <DealerPurchaseReportPage /> },
                        { path: 'activitylogpage', element: <ActivityLogPage /> },
                        { path: 'inventoryreportpage', element: <InventoryReportPage /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'dealersnsreportpage', element: <DealerSNSReportPage /> },
                        { path: 'grosssalesreportpage', element: <GrossSalesReportPage /> },
                        { path: 'standardpricereportpage', element: <StandardPriceReportPage /> },
                        { path: 'moduleroleaccesslistpage', element: <ModuleRoleAccessListPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },
        {
            path: '/reportuser',
            element: (
                <GuestGuard>
                    <ReportUserLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/reportuser/data/datapage' replace />, index: true },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to='/reportuser/data/datapage' replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                { element: <Navigate to='/reportuser/report/reportpage' replace />, index: true },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to='/reportuser/report/reportpage' replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'mysalesreportpage', element: <SalesReportPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },
        {
            path: '/dashboardandreportuser',
            element: (
                <GuestGuard>
                    <DashboardAndReportUserLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/dashboardandreportuser/datauploadapprove' replace />, index: true },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'dealerlistpage', element: <DealerListPage /> },
                { path: 'salesdashboard', element: <SalesDashboardPage /> },
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/dashboardandreportuser/master/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='masterlist' /> },
                        { path: ":masterName", element: <Masters importkey='master' /> },
                    ],
                },
                {
                    path: 'data',
                    children: [
                        { element: <Navigate to="datapage" replace />, index: true },
                        { path: 'datapage', element: <DataPage /> },
                        { path: "inventorypage", element: <InventoryPage /> },
                        { path: "grosssalepage", element: <GrossSalePage /> },
                    ],
                },
                { element: <Navigate to='/dashboardandreportuser/report/reportpage' replace />, index: true },
                {
                    path: 'report',
                    children: [
                        { element: <Navigate to="reportpage" replace />, index: true },
                        { path: 'reportpage', element: <ReportPage /> },
                        { path: 'dealerstatusdatareportpage', element: <DealerDataStatusReportPage /> },
                        { path: 'transactionreportpage', element: <TransactionReportPage /> },
                        { path: 'dealerreportedsnsreportpage', element: <DealerReportedSNSDataPage /> },
                        { path: 'dealerreportpage', element: <DealerPriceReport /> },
                        { path: 'salesreportpage', element: <SalesReportPage /> },
                        { path: 'ytddumpreportpage', element: <YTDDumpReportPage /> },
                    ],
                },
            ],
        },
        {
            path: '/masteruser',
            element: (
                <GuestGuard>
                    <MasterUserLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/masteruser/master/masterlist' replace />, index: true },
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/masteruser/master/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='masterlist' /> },
                        { path: ":masterName", element: <Masters importkey='master' /> },
                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                {
                    path: 'alliedmaster',
                    children: [
                        { element: <Navigate to="/masteruser/alliedmaster/alliedmasterlist" replace />, index: true },
                        { path: "alliedmasterlist", element: <MasterList name='alliedmasterlist' /> },
                        { path: ":masterName", element: <Masters importkey="alliedmaster" /> },
                        { path: ':masterName/stepone', element: <StepOne /> },
                        { path: ':masterName/stepthree', element: <StepThree /> },
                    ],
                },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'reloadzylemdata', element: <ReprocessZylemDataPage /> },
                { path: 'datamapping', element: <DataMappingPage /> },
                { path: 'datamapping/datamappingproductpage', element: <DataMappingProductPage /> },
                { path: 'datamapping/datamappingaccountpage', element: <DataMappingAccountPage /> },
                { path: 'datamapping/datamappingsurgeonpage', element: <DataMappingSurgeonPage /> },
                { path: "datamapping/datamappingimportstep1", element: <DataMappingImportStep1 /> },
                { path: "datamapping/:importName/datamappingimportstep2", element: <DataMappingImportStep2 /> },
                { path: "datamapping/:importName/datamappingimportstep3", element: <DataMappingImportStep3 /> },
                { path: "datamapping/:importName/datamappingdownloadstep2", element: <DataMappingDownloadStep2 /> },
                { path: 'enablereupload', element: <EnableReuploadPage /> },
                { path: 'configuration', element: <DistributorConfigurationPage /> },
                { path: "cutoffdatepage", element: <CutOffDatePage /> },
                { path: "franchisewisecutoff", element: <FranchiseWiseCutOffPage /> },
                { path: "helptopics", element: <HelpTopics /> },
                { path: "subcategory", element: <SubCategory /> },
                { path: 'helptopics/addedithelptopics', element: <AddEditHelpTopics /> },
                { path: 'subcategory/addeditsubcategory', element: <AddEditSubCategory /> },
                { path: ":masterName", element: <AdminMasters importkey='master' /> },
                { path: ':masterName/stepone', element: <StepOne /> },
                { path: ':masterName/stepthree', element: <StepThree /> },
            ],
        },
        {
            path: '/masterviewer',
            element: (
                <GuestGuard>
                    <MasterViewerLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to='/masterviewer/master/masterlist' replace />, index: true },
                {
                    path: 'master',
                    children: [
                        { element: <Navigate to="/masterviewer/master/masterlist" replace />, index: true },
                        { path: "masterlist", element: <MasterList name='masterlist' /> },
                        { path: ":masterName", element: <Masters importkey='master' /> },
                    ],
                },
                {
                    path: 'alliedmaster',
                    children: [
                        { element: <Navigate to="/masterviewer/alliedmaster/alliedmasterlist" replace />, index: true },
                        { path: "alliedmasterlist", element: <MasterList name='alliedmasterlist' /> },
                        { path: ":masterName", element: <Masters importkey="alliedmaster" /> },
                    ],
                },
                { path: 'datauploadapprove', element: <DataUploadApprovePage /> },
                { path: 'reloadzylemdata', element: <ReprocessZylemDataPage /> },
                { path: 'datamapping', element: <DataMappingPage /> },
                { path: 'datamapping/datamappingproductpage', element: <DataMappingProductPage /> },
                { path: 'datamapping/datamappingaccountpage', element: <DataMappingAccountPage /> },
                { path: 'datamapping/datamappingsurgeonpage', element: <DataMappingSurgeonPage /> },
                { path: "datamapping/datamappingimportstep1", element: <DataMappingImportStep1 /> },
                { path: "datamapping/:importName/datamappingdownloadstep2", element: <DataMappingDownloadStep2 /> },
                { path: 'enablereupload', element: <EnableReuploadPage /> },
                { path: 'configuration', element: <DistributorConfigurationPage /> },
                { path: "cutoffdatepage", element: <CutOffDatePage /> },
                { path: "franchisewisecutoff", element: <FranchiseWiseCutOffPage /> },
            ],
        },
        // ended CD002
    ]);
}
